import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {LoginWithGoogle} from "./LoginWithGoogle";
import {Navigate} from "react-router-dom";
import {Loading} from "../Loading";
import { withTranslation } from "react-i18next";

class LoginAcceptingInvitation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: null,
            accepting: false
        };

        this.handleGoogleLoginSuccessful = this.handleGoogleLoginSuccessful.bind(this);
        this.handleAcceptAuthenticated = this.handleAcceptAuthenticated.bind(this);
    }

    componentDidMount() {
        const isLoggedIn = LocalStorage.hasUserData();
        if(isLoggedIn) {
            this.defineIfItsLoggedOnAgencyData();
        } else {
            this.setState({
                isLoggedIn: false
            });
        }
    }

    handleGoogleLoginSuccessful(accountData) {
        const invitationData = {
            ...accountData,
            hash: this.props.hash
        };

        new APIClient(API_URL + 'invitation/accept').call('POST', invitationData)
            .then((response) => {
                if (response.status === 'ERROR_EXISTING_USER' || response.status === 'ERROR') {
                    alert(response['error_message']);
                } else if (response.status === 'OK') {
                    this.handleLoginSuccessful(response.data);
                }
            });
    }

    handleAcceptAuthenticated() {
        this.setState({ accepting: true });

        new APIClient(API_URL + 'invitation/accept-authenticated').call('POST', { hash: this.props.hash })
            .then((response) => {
                if (response.status === 'ERROR_EXISTING_USER' || response.status === 'ERROR') {
                    alert(response['error_message']);
                    this.setState({ accepting: false });
                } else if (response.status === 'OK') {
                    this.handleLoginSuccessful(response.data);
                }
            });
    }

    handleLoginSuccessful(responseData) {
        const userData = responseData.logged_user_data;

        LocalStorage.saveUserData(userData.user_id, userData.token, userData.user_type, userData.agency_status, userData.language, userData.client_id || null, userData.is_dashbo_mcp, userData.free_trial_days_remaining, userData.agency_logo_url, userData.agency_display_name, userData.brand_primary_color, userData.brand_secondary_color);

        this.setState({isLoggedIn: true});
    }

    _homePath() {
        return {pathname: "/"};
    }

    render() {
        const { t } = this.props;

        if (this.state.isLoggedIn === null) {
            return <Loading message={t('login.wait')}/>
        }

        if (this.state.isLoggedIn === true) {
            return <Navigate to={this._homePath()}/>;
        }

        if (this.state.isLoggedIn === 'authenticated') {
            return (
                <div className="invitation-accept-section">
                    <button
                        className="btn -alt"
                        onClick={this.handleAcceptAuthenticated}
                        disabled={this.state.accepting}
                    >
                        {this.state.accepting ? t('login.wait') : t('login.accept_invitation')}
                    </button>
                </div>
            );
        }

        return (
            <LoginWithGoogle
                onGoogleLoginSucessful={this.handleGoogleLoginSuccessful}
                buttonText={t('login.accept_invitation')}
            />
        );
    }

    agencyDataURL() {
        return API_URL + 'get-agency-data/'
    }

    defineIfItsLoggedOnAgencyData() {
        const { t } = this.props;
        new APIClient(this.agencyDataURL()).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if(data.status === 'ERROR_NO_AGENCY') {
                // Usuario autenticado sin agencia — puede aceptar directamente
                this.setState({
                    isLoggedIn: 'authenticated'
                });
            } else if (data.status === 'OK') {
                const userHasRealAgency = (data.general_data.has_clients);
                if(userHasRealAgency) {
                    alert(t('login.invitation_error_existing_agency'));
                    this.setState({ isLoggedIn: true });
                } else {
                    // Tiene agencia vacía (sin clientes) — puede aceptar directamente
                    this.setState({
                        isLoggedIn: 'authenticated'
                    });
                }
            }
        })
    }
}

export default withTranslation()(LoginAcceptingInvitation);
